import LabelProvider from "core/components/label/LabelProvider";

import MetaLabelProvider from "./component/labels";
import { Messages } from "common/Labels/Messages";
import { filters } from "common/Labels/Refine";
import { Course } from "common/Labels/Course";

export default LabelProvider.create({

	// include these ones for editing
	...MetaLabelProvider.getData(),

    ...filters,
    SubscriptionEmpty:{
        k:"subscriptions.empty.title",
        v:"No Subscriptions Found"
    },
    SubscriptionEmptyDescription: {
        k: "subscriptions.empty.description",
        v: "Launch a course to begin"
	},
    Yes: {
		k: "yes",
		v: "Yes"
	},
    Claim: {
		k: "Credit.Claim",
		v: "Claim"
	},
    ClaimComplete: {
		k: "Credit.Claim.Complete",
		v: "Credit Claim Complete"
	},
    PartialClaimMessage: {
		k: "Credit.Claim",
		v: "Claim credits for ${courseName}",
        argNames: ["courseName"]
	},
    ClaimCompleteMessage: {
		k: "Credit.Claim.Complete",
		v: "Are you sure claim credit is completed? Once clicked then you will not be able to claim more credits."
	},
    SubscriptionNoResults: {
        k: "subscriptions.noResults",
        v: "No results found"
    },
    SubscriptionNoResultsDescription: {
        k: "subscriptions.noResults.Description",
        v: "Please try again with different parameters"
    },

    Refresh: {
		k: "Subscription.Refresh",
		v: "Refresh"
	},
	...Messages,
	...Course

});



// WEBPACK FOOTER //
// ./src/panels/subscriptions/Subscriptions.labels.ts